<template>
  <div class="wrapper">
    <!-- tab按钮组 -->
    <div class="tabs-wrapper">
        <div
          v-for="(item, index) of list"
          :key="index"
          @click="clickSingle(item,index) "
          :class="['tab', tabSelectIndex === index ? 'tab-selected' : '']"
        >
          <div class="item-r">
            <div class="item-v">
              <span :class="['tabT', tabSelectItem === item ? 'tabT-selected' : '']">{{item}}</span>
              <div :class="['tabB', tabSelectItem === item ? 'tabB-selected' : '']"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="loadview">
        <div class="load-container load2">
            <div class="loader">
              <div class="loader-circle"></div>
            </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  name: 'FundChartload',
  components: {

  },
  props: {
  },
  computed: {
  },
  data() {
    return {
      tabSelectIndex: 0,
      tabSelectItem: '累计收益',
      list: [
        '累计收益',
        '单位净值',
        '累计净值',
      ],
    };
  },
  created() {
  },
  mounted() {
    // this.render();
  },
  methods: {
    render() {

    },
    clickSingle(item, index) {
      this.tabSelectItem = item;
      this.tabSelectIndex = index;
    },
  },
};
</script>

<style scoped lang="less">
.wrapper{
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
  border-radius: 12px;
  background-color: #ffffff;
}
.inner {
  background-color: #ffffff;
  padding-bottom:10px;
  border-radius: 12px;
}
.tabs-wrapper {
  display: flex;
  height: 88px;
  border-radius: 12px;
  padding-top: 12px;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
}
.tip-icon-t {
  height: 24px;
  width: 24px;
  padding-bottom: 0px;
  padding-left: 22px;
  padding-right: 18px;
  margin-top: 30px;

}
.tab {
  display: flex;
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.tab-selected {
  font-size: 32px;
  color: #000;
  font-weight: bold;
}
.tabT {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
}
.tabT-selected {
  font-size: 32px;
  color: #000;
  font-weight: bold;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tabB-selected {
  background-color:#ff4400;
}
.item-r{
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.item-v{
  position: relative;
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.right-button {
  position: absolute;
  right: 60px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #008AFF;
  border-radius: 25px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #008AFF;
  width: 160px;
  z-index: 9;
  margin-top: 30px;
}
.loadview{
  width: 100%;
  height: 688px;
  background-color: #ffffff;
  border-radius: 12px;
  display: flex;
  border-radius: 12px;
  background-color: #ffffff;
  align-items: center;
  justify-content: center;
}
</style>
